import styled from "@emotion/styled";

import {
    reactUiModalHeaderBottomPadding,
    reactUiModalLeftPadding,
    reactUiModalRightPadding,
} from "../../../../Internals/ThemeProvider/ReactUiModalPaddings";
import { sizeToken } from "../../../../Internals/ThemeProvider/CandyTheme/ThemeBuilder/ICandyTheme";
import { theme } from "../../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const NormativeHelpContainer = styled.div(props => ({
    fontSize: theme(props).typography.primary.fontSize.css(),
    marginBottom: sizeToken(1),
}));

export const HelpIconWrapper = styled.span(props => ({
    color: theme(props).semanticColors.action.color,
}));

export const ExceptionText = styled.div(props => ({
    color: props.theme.candy.semanticColors.danger.color,
}));

export const PicklistHint = styled.span<{ width: number }>(props => ({
    display: "block",
    width: props.width,
    marginBottom: sizeToken(1),
    fontSize: theme(props).typography.primary.fontSize.css(),
    lineHeight: theme(props).typography.primary.lineHeight.css(),
}));

export const SearchContainer = styled.div<{ textRenderTotalCount: string }>(props => ({
    padding: "10px 0",
    paddingBottom: `${props.textRenderTotalCount ? sizeToken(0.5) : sizeToken(1)}px`,
    lineHeight: "16px",
    fontSize: theme(props).typography.primary.fontSize.css(),
}));

export const TotalCountContainer = styled.div(props => ({
    fontSize: theme(props).typography.primary.fontSize.css(),
    color: theme(props).typography.secondary.color,
    width: 700,
}));

const reactUICheckboxWidthAndPadding = 14 + 10;

interface HeaderProps {
    checkable: boolean;
    decreasedPadding: boolean;
}

export const Header = styled.div<HeaderProps>(
    props => ({
        width: 700,
        fontWeight: 400,
        paddingTop: sizeToken(1),
        color: theme(props).typography.secondary.color,
        fontSize: theme(props).typography.primary.fontSize.css(),
        marginBottom: sizeToken(0.5),
    }),
    props =>
        props.checkable && {
            marginLeft: reactUICheckboxWidthAndPadding,
        }
);

export const HeaderCell = styled.div<{ width: string | number }>(props => ({
    marginRight: sizeToken(2),
    width: props.width,
    display: "inline-flex",

    ":last-of-type": {
        marginRight: 0,
    },
}));

export const HeaderLine = styled.div<{ decreasedPadding: boolean; width: number }>(props => ({
    marginBottom: props.decreasedPadding ? -reactUiModalHeaderBottomPadding : -reactUiModalHeaderBottomPadding / 2,
    width: props.width,
    height: 1,
    backgroundColor: theme(props).border.color,
}));

export const BodyContainer = styled.div(props => ({
    ...theme(props).typography.primary.css(),
    minHeight: 200,
    marginLeft: -reactUiModalLeftPadding,
    marginRight: -reactUiModalRightPadding,
    outline: 0,
}));

export const CustomFooterContainer = styled.div(
    (props: { increaseBottomMargin: boolean }) =>
        props.increaseBottomMargin && {
            marginBottom: sizeToken(2),
        }
);
